'use client';

import clsx from 'clsx';
import { useRouter, useSearchParams } from 'next/navigation';

import { Button } from '@/components/atoms';

export const LeaguesPastFutureFilter = () => {
	const router = useRouter();
	const searchParams = useSearchParams();
	const activeButton = searchParams?.get('status') ?? 'active';

	const handlePageChange = (status: 'active' | 'past') => {
		const newSearchParams = new URLSearchParams(searchParams || '');
		newSearchParams.set('status', status);
		router.replace(`?${newSearchParams.toString()}`);
	};

	return (
		<div className="mt-4 flex gap-4">
			<Button
				onClick={() => handlePageChange('active')}
				className={clsx('border', {
					'border-darkorange-600 bg-darkorange-100 text-darkorange-600': activeButton !== 'past',
					'border-gray-300 bg-transparent text-gray-900': activeButton === 'past'
				})}
			>
				Current & Future
			</Button>
			<Button
				onClick={() => handlePageChange('past')}
				className={clsx('border', {
					'border-darkorange-600 bg-darkorange-100  text-darkorange-600': activeButton === 'past',
					'border-gray-300 bg-transparent text-gray-900': activeButton !== 'past'
				})}
			>
				Past
			</Button>
		</div>
	);
};
